import * as React from 'react';

import { cn } from '@/components/atoms/primitives/utils';

export interface PageContainerProps {
  children: React.ReactNode;
  className?: string;
  /** Optional test id on the wrapper. */
  testId?: string;
}

/**
 * Shared marketing-page inner (FRE-1335 / P0-1).
 *
 * Width is `--page-container` (1216px) with `--page-gutter` inline padding so
 * hero copy, section titles, and the footer lockup share one left edge with
 * the chrome lockup (chrome uses `.page-chrome-inline`).
 */
export function PageContainer({
  children,
  className,
  testId,
}: PageContainerProps): React.ReactElement {
  return (
    <div className={cn('page-container', className)} data-testid={testId}>
      {children}
    </div>
  );
}
